var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPortal)?_c('v-list-item-title',{on:{"click":_vm.logout}},[_vm._v(" Logout ")]):_c('v-btn',{attrs:{"text":""},on:{"click":_vm.logout}},[_vm._v(" Logout ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }